import { Fragment, useState } from "react";
import { SentimentValue, ChannelValue } from "@/components/ai-consumer-research/live-feed/filters";
import { Activity } from "lucide-react";
import { createFileRoute } from "@tanstack/react-router";
import { Feed } from "@/components/ai-consumer-research/live-feed/feed";
import { Filters } from "@/components/ai-consumer-research/live-feed/filters";

export const Route = createFileRoute("/dashboard/consumer-research/_layout/social-feed")({
  component: LiveFeed,
});

export function LiveFeed() {
  const [sentimentFilter, setSentimentFilter] = useState<SentimentValue>("All");
  const [channelFilter, setChannelFilter] = useState<ChannelValue>("All");

  return (
    <Fragment>
      <div className="flex items-center gap-2 mb-6">
        <Activity size={16} />
        <h2 className="text-lg font-semibold text-foreground">Social Feed</h2>
      </div>
      <div className="space-y-4">
        <Filters sentimentValue={sentimentFilter} onSentimentChange={setSentimentFilter} channelValue={channelFilter} onChannelChange={setChannelFilter} />
        <Feed sentimentFilter={sentimentFilter} channelFilter={channelFilter} />
      </div>
    </Fragment>
  );
}
